import { validationObject, validateRange } from 'utils/validations';
import { BASE_ASSET_CATEGORY } from 'utils/constants/assetText';

export const transportServiceOption = [
  { name: 'Transport Standard', id: 'TRANSPORT_STANDARD' },
  { name: 'Transport Secure', id: 'TRANSPORT_SECURE' },
  { name: 'Transport Protection', id: 'TRANSPORT_PROTECTION' },
];
export const vehicleCategoryOption = [
  { name: 'Vehicle', id: BASE_ASSET_CATEGORY.VEHICLE.id },
  { name: 'Van', id: BASE_ASSET_CATEGORY.VEHICLE_VAN.id },
  { name: 'Bus', id: BASE_ASSET_CATEGORY.VEHICLE_BUS.id },
  { name: 'Off Road', id: BASE_ASSET_CATEGORY.VEHICLE_OFF_ROAD.id },
];

const isServiceTypePriceRangeNotEmpty = serviceTypePriceRange => {
  return Object.keys(serviceTypePriceRange).length > 0;
};

const getAssetTypeValues = (assetTypeList, assetCategory) => {
  return assetTypeList.reduce((filtered, assetType) => {
    if (assetType.category.id === assetCategory) {
      filtered.push({ id: assetType.name, name: assetType.name });
    }
    return filtered;
  }, []);
};

export const generalSection = ({
  services,
  assetType,
  selectedCategory,
  regionCurrencySymbol,
  serviceTypePriceRange,
}) => {
  const serviceTypePriceRangeNotEmpty = isServiceTypePriceRangeNotEmpty(
    serviceTypePriceRange,
  );
  return [
    {
      field: 'serviceType',
      type: 'select',
      required: true,
      size: 'half',
      options: transportServiceOption.filter(transportSerive =>
        services.includes(transportSerive.id),
      ),
    },
    {
      field: 'vehicleCategory',
      type: 'select',
      required: true,
      size: 'half',
      options: vehicleCategoryOption,
    },
    {
      field: 'vehicleType',
      type: 'select',
      required: true,
      size: 'half',
      options: getAssetTypeValues(assetType, selectedCategory),
    },
    {
      field: 'client',
      type: 'sub-panel',
      panelHeader: 'Prices',
      imageRequired: false,
      styleInfo: {
        noBorder: true,
        showFieldInColumn: true,
      },
      subFields: [
        {
          field: 'srFlagFall',
          type: 'text',
          required: true,
          size: 'half',
          disabled: true,
          startAdornment: regionCurrencySymbol,
        },
        {
          field: 'srSharePercentOnCost',
          type: 'text',
          required: true,
          size: 'half',
          disabled: true,
          startAdornment: '%',
        },
        {
          field: 'flagFall',
          type: 'text',
          fieldType: 'number',
          required: true,
          size: 'half',
          placeholder: serviceTypePriceRangeNotEmpty
            ? `price should be between ${regionCurrencySymbol}${serviceTypePriceRange.minFlagFall} and ${regionCurrencySymbol}${serviceTypePriceRange.maxFlagFall}`
            : ' ',
          startAdornment: regionCurrencySymbol,
        },
        {
          field: 'costPerKM',
          type: 'text',
          fieldType: 'number',
          required: true,
          size: 'half',
          placeholder: serviceTypePriceRangeNotEmpty
            ? `price should be between ${regionCurrencySymbol}${serviceTypePriceRange.minCostPerKM} and ${regionCurrencySymbol}${serviceTypePriceRange.maxCostPerKM}`
            : ' ',
          startAdornment: regionCurrencySymbol,
        },
        {
          field: 'costPerMin',
          type: 'text',
          fieldType: 'number',
          required: true,
          size: 'half',
          placeholder: serviceTypePriceRangeNotEmpty
            ? `price should be between ${regionCurrencySymbol}${serviceTypePriceRange.minCostPerMin} and ${regionCurrencySymbol}${serviceTypePriceRange.maxCostPerMin}`
            : ' ',
          startAdornment: regionCurrencySymbol,
        },
      ],
    },
  ];
};

export const baseInitialState = {
  serviceType: '',
  vehicleCategory: '',
  vehicleType: '',
  srFlagFall: '0',
  srSharePercentOnCost: '0',
  flagFall: '',
  costPerKM: '',
  costPerMin: '',
};

export const initialState = (priceRangeData, currentFormValues) => {
  if (
    Object.keys(priceRangeData).length > 0 &&
    Object.keys(currentFormValues).length > 0
  ) {
    return {
      serviceType: currentFormValues.serviceType,
      vehicleCategory: currentFormValues.vehicleCategory,
      vehicleType: currentFormValues.vehicleType,
      srFlagFall: priceRangeData.srFlagFall,
      srSharePercentOnCost: priceRangeData.srSharePercentOnCost,
      flagFall: currentFormValues.flagFall,
      costPerKM: currentFormValues.costPerKM,
      costPerMin: currentFormValues.costPerMin,
    };
  } else {
    return baseInitialState;
  }
};

const baseValidation = (priceRangeData, currencySymbol) => {
  return {
    flagFall: validateRange(
      priceRangeData.minFlagFall,
      priceRangeData.maxFlagFall,
      currencySymbol,
    ),
    costPerKM: validateRange(
      priceRangeData.minCostPerKM,
      priceRangeData.maxCostPerKM,
      currencySymbol,
    ),
    costPerMin: validateRange(
      priceRangeData.minCostPerMin,
      priceRangeData.maxCostPerMin,
      currencySymbol,
    ),
  };
};

export const validationSchema = (serviceTypePriceRange, currencySymbol) => {
  if (Object.keys(serviceTypePriceRange).length > 0) {
    return validationObject(
      baseValidation(serviceTypePriceRange, currencySymbol),
    );
  }
  return null;
};
